<template>
  <div class="show-hide-container">
    <div v-for="field in fields" :key="field.name">
      <transition name="fadeHeight">
        <component :is="formTypeToComposantName(field.type)" v-if="init ? rulesData[field.name].show : true"
          class="input-block-container" :class="{
      'input-instance-block-inline': field.displayInline && field.type === 'input-block',
      'input-instance-block': !field.displayInline && field.type === 'input-block',
      hidden: field.hidden
    }" :style="field.duplicate_element ? 'width: 87%;margin-right: 13px' : null" v-bind="field" :lastIndex="lastIndex && lastIndex[field.name] ? lastIndex[field.name] : typeof lastIndex === 'number' ? lastIndex : 0
      " :checkBoxUniq="checkBoxUniq" :checkboxChildrenValue="checkboxChildrenValue" @add-data="
      $emit(
        'addData',
        field.duplicate_element ? { ...$event, ...{ duplicateElement: field.duplicateElementIndex } } : $event
      ),
      addedData($event)
      " @add="$emit('add', $event)" @delete="$emit('delete', $event)" @clear="$emit('clear', $event)"
          @set-default="$emit('setDefault', $event)" @only-one-selected-name="$emit('onlyOneSelectedName', $event)"
          @check-box-children-show="$emit('checkBoxChildrenShow', $event)" />
      </transition>
    </div>
  </div>
</template>

<script>
import BasicTextInput from '@/components/GenericComponents/Form/BasicTextInput.vue'
import BasicNumberInput from '@/components/GenericComponents/Form/BasicNumberInput.vue'
import BasicCheckbox from '@/components/GenericComponents/Form/BasicCheckbox.vue'
import BasicDateInput from '@/components/GenericComponents/Form/BasicDateInput.vue'
import BasicFileInput from '@/components/GenericComponents/Form/BasicFileInput.vue'
import BasicPasswordInput from '@/components/GenericComponents/Form/BasicPasswordInput.vue'
import BasicEmailInput from '@/components/GenericComponents/Form/BasicEmailInput.vue'
import BasicRadioInput from '@/components/GenericComponents/Form/BasicRadioInput.vue'
import BasicRangeInput from '@/components/GenericComponents/Form/BasicRangeInput.vue'
import BasicSelect from '@/components/GenericComponents/Form/BasicSelect.vue'
import BasicAutocomplete from '@/components/GenericComponents/Form/BasicAutocomplete.vue'
import BasicTextArea from '@/components/GenericComponents/Form/BasicTextArea.vue'
import BasicTimeInput from '@/components/GenericComponents/Form/BasicTimeInput.vue'
import FormFullScreen from '@/components/GenericComponents/Form/FormFullScreen.vue'
import BetweenDateFullScreen from '@/components/GenericComponents/Form/BetweenDateFullScreen.vue'
import BetweenMinMax from '@/components/GenericComponents/Form/BetweenMinMax.vue'
import FormSearchCustomer from '@/components/GenericComponents/Form/FormSearchCustomer.vue'
import BasicScanInput from '@/components/GenericComponents/Form/BasicScanInput.vue'
import InputBlockCheckbox from '@/components/GenericComponents/Form/InputBlockCheckbox.vue'
import CheckboxInput from '@/components/GenericComponents/Form/CheckboxInput.vue'
import CustomNumberInput from '@/components/GenericComponents/Form/CustomNumberInput.vue'
import CustomPhoneInput from '@/components/GenericComponents/Form/CustomPhoneInput.vue'
import CustomLanguageInput from '@/components/GenericComponents/Form/CustomLanguageSelect.vue'
import SpanElement from '@/components/GenericComponents/Form/SpanElement.vue'
import InputBlock from '@/components/GenericComponents/Form/InputBlock.vue'
import BasicHiddenInput from '@/components/GenericComponents/Form/BasicHiddenInput.vue'
import CustomCountrySelect from '@/components/GenericComponents/Form/CustomCountrySelect.vue'
import FormCalendar from '@/components/GenericComponents/Form/FormCalendar.vue'
import AddRemoveButtons from '@/components/GenericComponents/AddRemoveButtons.vue'
import FullScreenDayMonthInterval from '@/components/GenericComponents/Form/FullScreenDayMonthInterval.vue'
import { mapState } from 'pinia'
import { store } from '@/stores/index.js'
import { findBestMatch } from 'string-similarity'
import { EventBus } from '@/event-bus'

export default {
  name: 'ShowHide',
  components: {
    BasicTextInput,
    BasicNumberInput,
    BasicCheckbox,
    BasicDateInput,
    BasicFileInput,
    BasicPasswordInput,
    BasicEmailInput,
    BasicRadioInput,
    BasicRangeInput,
    BasicSelect,
    BasicAutocomplete,
    BasicTextArea,
    BasicTimeInput,
    FormFullScreen,
    BetweenDateFullScreen,
    BetweenMinMax,
    FormSearchCustomer,
    BasicScanInput,
    InputBlockCheckbox,
    CheckboxInput,
    CustomNumberInput,
    CustomPhoneInput,
    CustomLanguageInput,
    SpanElement,
    InputBlock,
    BasicHiddenInput,
    CustomCountrySelect,
    FormCalendar,
    AddRemoveButtons,
    FullScreenDayMonthInterval
  },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: [String, Number],
    defaultValue: {
      type: [String, Array, Object, Boolean],
      default: undefined
    },
    name: String,
    dataOptions: Array,
    apiUrl: String,
    uniqueApiCall: {
      type: Boolean,
      default: false
    },
    lastIndex: {
      type: [Number, Object]
    },
    checkboxChildrenValue: {
      type: [Boolean, Object]
    },
    labelFields: Array,
    translate: Boolean,
    displayLabel: {
      type: Boolean,
      default: false
    },
    checkBoxUniq: {
      type: Object
    },
    getChildByName: {
      type: Function,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    selectPlaceholder: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: null
    },
    fields: {
      type: Array,
      default: null
    }
  },
  emits: ['add', 'delete', 'clear', 'setDefault', 'onlyOneSelectedName', 'checkBoxChildrenShow', 'addData'],
  data() {
    return {
      mutatedValue: this.defaultValue,
      mutatedDataOptions: this.dataOptions,
      url: null,
      autocomplete_: {},
      init: false,
      rulesData: this.rules,
      shouldForceUpdate: false
    }
  },
  computed: {
    ...mapState(store, ['formApiResponses']),
    computedMutatedValue: {
      get() {
        if (this.mutatedValue) {
          if (typeof this.mutatedValue === 'object') {
            return {
              ...this.mutatedValue,
              formGeneratorLabel: this.buildLabel(this.mutatedValue)
            }
          } else {
            return this.mutatedValue
          }
        } else {
          return undefined
        }
      },
      set(value) {
        let newValue = JSON.parse(JSON.stringify(value))
        if (newValue && typeof newValue === 'object') {
          delete newValue.formGeneratorLabel
        }
        this.mutatedValue = newValue
      }
    },
    computedMutatedDataOptions() {
      if (this.mutatedDataOptions) {
        return this.mutatedDataOptions.map(option => {
          return {
            ...option,
            formGeneratorLabel: this.buildLabel(option)
          }
        })
      } else {
        return []
      }
    }
  },
  watch: {
    autocomplete_(value) {
      if (value.list && value.list.length > 0) {
        const bestMatch = findBestMatch(
          value.list[0],
          this.mutatedDataOptions.map(o => this.buildLabel(o))
        )

        if (bestMatch) {
          this.mutatedValue = this.mutatedDataOptions[bestMatch.bestMatchIndex]
        }
      }
    },
    defaultValue() {
      if (this.mutatedValue === undefined) {
        this.mutatedValue = this.defaultValue
        if (this.apiUrl && this.mutatedValue) {
          this.$emit('addData', { value: JSON.parse(JSON.stringify(this.mutatedValue)), name: this.name })
          EventBus.emit('formGeneratorValueChanged', {
            name: this.name,
            value: this.mutatedValue
          })
        }
      }
    }
  },
  mounted() {
    if (this.apiUrl) {
      this.buildAPIURL()
      EventBus.on('formGeneratorValueChanged', () => {
        this.buildAPIURL()
      })
    }
    this.emitData()
    this.initForceUpdateIfCustomCountryIsMainField()
    this.init = true
  },
  beforeUnmount() {
    EventBus.off('formGeneratorValueChanged')
  },
  methods: {
    formTypeToComposantName(formType) {
      switch (formType) {
        case 'text':
          return 'BasicTextInput'
        case 'number':
          return 'BasicNumberInput'
        case 'range':
          return 'BasicRangeInput'
        case 'password':
          return 'BasicPasswordInput'
        case 'date':
          return 'BasicDateInput'
        case 'radio':
          return 'BasicRadioInput'
        case 'checkbox':
          return 'BasicCheckbox'
        case 'checkbox-input':
          return 'CheckboxInput'
        case 'email':
          return 'BasicEmailInput'
        case 'file':
          return 'BasicFileInput'
        case 'time':
          return 'BasicTimeInput'
        case 'full-screen':
          return 'FormFullScreen'
        case 'full-screen-between-date':
          return 'BetweenDateFullScreen'
        case 'full-screen-between-date-birthdate':
          return 'BetweenDateFullScreen'
        case 'full-screen-min-max':
          return 'BetweenMinMax'
        case 'search-customer':
          return 'FormSearchCustomer'
        case 'select':
          return 'BasicSelect'
        case 'autocomplete':
          return 'BasicAutocomplete'
        case 'textarea':
          return 'BasicTextArea'
        case 'custom-phone':
          return 'CustomPhoneInput'
        case 'custom-language':
          return 'CustomLanguageInput'
        case 'custom-number':
          return 'CustomNumberInput'
        case 'hidden':
          return 'BasicHiddenInput'
        case 'custom-country':
          return 'CustomCountrySelect'
        case 'scan-input':
          return 'BasicScanInput'
        case 'span':
          return 'SpanElement'
        case 'date-picker':
          return 'FormCalendar'
        case 'input-block':
          return 'InputBlock'
        case 'input-block-checkbox':
          return 'InputBlockCheckbox'
        case 'day-month-interval':
          return 'FullScreenDayMonthInterval'
        case 'show-hide':
          return 'ShowHide'

        default:
          console.error(
            `Form element type ${formType} cannot be generated. Did you mean : text, number, range, password, date, radio, checkbox, email, file, time, select, textarea, custom-phone, custom-number, custom-country, hidden, span ? \n
              If you want to learn more about it, check the documentation : https://wiki.octipas.net/index.php/Formgenerator`
          )
          return null
      }
    },
    buildAPIURL() {
      let url = this.apiUrl
      const findVars = this.apiUrl.match(/{[^{]*}/g)
      if (findVars) {
        findVars.forEach(variable => {
          const value = this.getChildByName(variable.slice(1, -1))
          if (value) {
            url = url.replace(variable, value)
            this.url = url
          }
        })
      } else {
        this.url = url
      }
    },
    emitData() {
      if (this.mutatedValue !== undefined && this.mutatedValue !== null) {
        this.$emit('addData', { value: JSON.parse(JSON.stringify(this.mutatedValue)), name: this.name })
        if (this.apiUrl) {
          EventBus.emit('formGeneratorValueChanged', {
            name: this.name,
            value: this.mutatedValue
          })
        }
      } else {
        this.$emit('addData', { value: '', name: this.name })
      }
    },
    addedData(event) {
      // set the currentValue of child fields
      // used for managing show/hide
      if (this.rulesData[event.name]) {
        this.rulesData[event.name].currentValue = event.value
        this.$emit('addData', {
          name: event.name,
          value: event.value
        })
        this.manageShowHideFields()
      }
    },
    manageShowHideFields() {
      for (let rule of Object.entries(this.rulesData)) {
        let show = false
        let count = 0
        // if there is a rule for show/hide
        if (rule[1].showWhen) {
          for (let ruleShow of Object.entries(rule[1].showWhen)) {
            let keys = ruleShow[0].split('.')
            let countGoal = 0
            let splittedRule = null
            if (rule?.[1]?.generalRuleType && rule[1].generalRuleType.includes(':')) {
              splittedRule = rule[1].generalRuleType.split(':')
            }

            if (rule[1].generalRuleType === 'all') {
              countGoal = Object.keys(rule[1].showWhen).length
            } else if (splittedRule?.length) {
              countGoal = Number(splittedRule[1])
            }

            // if keys are like "type.name"
            if (keys.length > 1) {
              // strict mode -> value need to be exact the same as expected
              if (ruleShow[1].fieldRuleType === 'strict') {
                if (this.rulesData[keys[0]].currentValue[keys[1]] == ruleShow[1].value) {
                  // if condition is ok, count +1
                  count++
                  // if the countGoal is reach, show the field
                  if (countGoal == count) {
                    show = true
                    this.rulesData[rule[0]].show = show
                    break
                  }
                }
              } else if (ruleShow[1].fieldRuleType === 'isSet') {
                // isSet mode -> check if the targeted field has value
                if (this.rulesData[keys[0]].currentValue[keys[1]]) {
                  count++
                  if (countGoal == count) {
                    show = true
                    this.rulesData[rule[0]].show = show
                    break
                  }
                }
              }
            } else {
              if (ruleShow[1].fieldRuleType === 'strict') {
                if (this.rulesData[keys[0]].currentValue == ruleShow[1].value) {
                  count++
                  if (countGoal == count) {
                    show = true
                    this.rulesData[rule[0]].show = show
                    break
                  }
                }
              } else if (ruleShow[1].fieldRuleType === 'isSet') {
                if (this.rulesData[keys[0]].currentValue) {
                  count++
                  if (countGoal == count) {
                    show = true
                    this.rulesData[rule[0]].show = show
                    break
                  }
                }
              }
            }
          }
          this.rulesData[rule[0]].show = show
          if (this.shouldForceUpdate) {
            this.$forceUpdate()
          }
          if (!show) {
            this.$emit('addData', {
              name: rule[0],
              value: null
            })
          }
        } else {
          this.rulesData[rule[0]].show = true
        }
      }
    },
    buildLabel(option) {
      if (this.translate) {
        if (option.label) {
          return this.$te(option.label) ? this.$t(option.label) : option.label
        }
        return this.$t('form.' + option[this.labelFields[0]])
      }
      if (!this.apiUrl) {
        return this.$te('form.' + option.label) ? this.$t('form.' + option.label) : option.label
      }
      if (!this.labelFields) {
        return option.label
      }

      return this.labelFields.map(field => option[field]).join(' ')
    },
    getOptionKey(option) {
      try {
        return JSON.stringify(option)
      } catch (e) {
        if (typeof option === 'object' && option.id) {
          return option.id
        }
        return null
      }
    },
    initForceUpdateIfCustomCountryIsMainField() {
      const keys = Object.keys(this.rules)
      let found = false
      let inc = 0
      while (!found && inc < keys.length) {
        const value = this.rules[keys[inc]]
        if (typeof value.showWhen != 'undefined' && value.showWhen == null) {
          const field = this.fields.find(field => field.name == keys[inc])

          this.shouldForceUpdate =
            typeof field != 'undefined' &&
            field != null &&
            typeof field.type != 'undefined' &&
            field.type != null &&
            field.type == 'custom-country'

          found = true
        }
        inc++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.show-hide-container {
  display: flex;
  flex-direction: column;
}

.basic-select-input-container {
  margin: 10px 0;

  .basic-select-input-container-main {
    text-align: left;

    label {
      padding-left: 12px;
      color: #777;
      font-size: 0.75rem !important;
      font-weight: bold;
    }
  }

  .basic-select-input-content {
    width: 100%;
    white-space: nowrap;
    align-items: center;
    padding-left: 0.5rem;
  }
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.2s !important;
  max-height: 230px;
  margin: 10px 0;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
  transition: all 0.2s !important;
  margin: 0 !important;

  // opacity: 0;
  max-height: 0;
}
</style>

<style lang="scss">
.basic-select-input-container {
  .custom-select-style input {
    height: 100%;
    border: none;
  }

  .vs__dropdown-toggle {
    display: flex;
    align-items: center;
  }

  .vs__selected-options {
    margin-right: 5px;
  }

  .custom-select-style * {
    padding: 0 0 1px !important;
    border: none !important;
  }

  .custom-select-style .vs__clear {
    fill: transparent;
    background-image: url('@/assets/icons/cancel.svg');
    background-position: center right;
    background-origin: content-box;
    background-repeat: no-repeat;
    background-size: contain;
    width: 1rem;
    height: 1rem;
    margin-right: 8px !important;
  }
}
</style>
